import { LOCAL_STORAGE } from "@constants/index";

const AWAITING_KEY = LOCAL_STORAGE.AWAITING_UPDATE_SUMMARY;
/** Drop stale awaiting flags so a never-finished update cannot poll forever. */
const AWAITING_TTL_MS = 60 * 60 * 1000;
/** Module init time = this page load; used to tell in-tab updates from recovery. */
const PAGE_LOADED_AT = Date.now();

/** Mark that an auto-update is running and its summary has not been shown yet. */
export function setAwaitingUpdateSummary() {
  localStorage.setItem(AWAITING_KEY, String(Date.now()));
}

/** Clear once the summary is displayed or acknowledged. */
export function clearAwaitingUpdateSummary() {
  localStorage.removeItem(AWAITING_KEY);
}

/**
 * True only when the update started before this page loaded — the tab was
 * refreshed or logged in again mid-update, so no AutoUpdateModal is driving it.
 */
export function isRecoveringUpdateSummary() {
  const raw = localStorage.getItem(AWAITING_KEY);
  if (!raw) {
    return false;
  }
  const startedAt = Number(raw);
  if (!Number.isFinite(startedAt) || Date.now() - startedAt > AWAITING_TTL_MS) {
    localStorage.removeItem(AWAITING_KEY);
    return false;
  }
  return startedAt < PAGE_LOADED_AT;
}
